import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Row, Col, Table, Button, Tooltip, OverlayTrigger, Glyphicon } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import CampaignGroupModalPage from '../../../containers/masters/CampaignGroup/CampaignGroupModalPage'
import InputSelect from '../../commons/form/InputSelect'

class CampaignGroupMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchCode: null,
        searchClassId: null
      }
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchCampaignGroupList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchCampaignGroupList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (searchCode) {
    if (this.state.filter.searchName !== searchCode) {
      this.setState({ filter: { ...this.state.filter, searchCode } })
    }
  }

  handleClassChange (searchClassId) {
    if (this.state.filter.searchClass !== searchClassId) {
      this.setState({ filter: { ...this.state.filter, searchClassId } })
    }
  }

  searchCampaign () {
    this.props.actions.fetchCampaignGroupList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchCode: null,
        searchClassId: null
      }
    }, () => { this.searchCampaign() })
  }

  render () {
    const {
      t, campaignGroupList, pagesCount, campaignGroupCount, filter,
      combos: { campaignClass },
      filter: { page },
      actions: { openCampaignGroupModal, fetchCampaignGroupList, recoverCampaignGroup, deleteCampaignGroup, openEditDocumentalConditionModalSuccess }
    } = this.props

    const tKey = 'MASTERS.CAMPAIGN_GROUP_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const documentTooltip = (<Tooltip id="documentTooltip">{t(`${tKey}DOCUMENTAL_CONDITIONS`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchClassId || this.state.filter.searchCode)
    return (
      <div className="admin-wrapper">
        <CampaignGroupModalPage/>
        <Row className="section-users-header">
          <Col sm={12}>
            <div className="header-panel">
              <h4>{t(`${tKey}CAMPAIGN_GROUP`)}</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="search-form">
            <span className="title-search"><i className="ico-search" /> {t(`${tKey}SEARCH_TITLE`)}</span>
            <Row>
              <Field
                name="filters.code"
                colSm={4}
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                component={InputText}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                name="filters.campaignClassId"
                colSm={4}
                controlLabel={t(`${tKey}CLASSTYPE`)}
                placeholder={t(`${tKey}CLASSTYPE`)}
                valueKey="id"
                labelKey="value"
                component={InputSelect}
                options={campaignClass}
                onInputChange={(value) => this.handleClassChange(value)}
              />
              <Col sm={4} className="btn-wrapper">
                <p></p>
                <Button
                  className={'btn-white btn-icon btn-input btn-white search-button'}
                  style={{ width: '100%' }}
                  onClick={() => this.searchCampaign()}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'btn-icon btn-input ' + (hasFilters ? 'btn-standard' : 'btn-cancel')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </Col>
            </Row>
          </div>
        </Row>
        <Col sm={12} className="col-row  section-users-body">
          <Table className="editable-table" hover responsive>
            <thead>
              <tr>
                <th onClick={() => { this.changeOrder('code') }}>
                  {t(`${tKey}CODE`)}
                  <i className={this.getSortIcon('code')} />
                </th>
                <th onClick={() => { this.changeOrder('name') }}>
                  {t(`${tKey}NAME`)}
                  <i className={this.getSortIcon('name')} />
                </th>
                <th onClick={() => { this.changeOrder('description') }}>
                  {t(`${tKey}DETAILS`)}
                  <i className={this.getSortIcon('description')} />
                </th>
                <th onClick={() => { this.changeOrder('classCode') }}>
                  {t(`${tKey}CLASSTYPE`)}
                  <i className={this.getSortIcon('classCode')} />
                </th>
                <th style={{ width: '100px' }}>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
              </tr>
            </thead>
            <tbody>
              {campaignGroupList && campaignGroupList.map((campaignGroup, idx) => {
                return (
                  <tr key={idx} className={campaignGroup.isDeleted ? 'is-deleted' : ''}>
                    <td>{campaignGroup.groupCode}</td>
                    <td>{campaignGroup.campaignGroupLanguage && campaignGroup.campaignGroupLanguage.length > 0 ? campaignGroup.campaignGroupLanguage.find(lang => (lang.languageId ? lang.languageId : '') === this.props.languageSelected).name : ''} </td>
                    <td>{campaignGroup.campaignGroupLanguage && campaignGroup.campaignGroupLanguage.length > 0 ? campaignGroup.campaignGroupLanguage.find(lang => (lang.languageId ? lang.languageId : '') === this.props.languageSelected).description : ''} </td>
                    <td>{campaignGroup.campaignClassCode}</td>
                    <td>
                      {!campaignGroup.isDeleted ? (
                        <div>
                          {!campaignGroup.isCampaign && (
                            <a onClick={() => openEditDocumentalConditionModalSuccess(campaignGroup, this.props.languageSelected)}>
                              <OverlayTrigger placement="left" overlay={documentTooltip}>
                                <i className="ico-document-lines" />
                              </OverlayTrigger>
                            </a>)}
                          <a onClick={() => openCampaignGroupModal(campaignGroup)}>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <i className="ico-edit-white" />
                            </OverlayTrigger>
                          </a>
                          <a onClick={() => deleteCampaignGroup(campaignGroup.campaignGroupId)}>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <i className="ico-trash" />
                            </OverlayTrigger>
                          </a>
                        </div>
                      ) : (
                        <a onClick={() => recoverCampaignGroup(campaignGroup.campaignGroupId)}>
                          <OverlayTrigger placement="left" overlay={recoverTooltip}>
                            <Glyphicon glyph="repeat" />
                          </OverlayTrigger>
                        </a>
                      )}
                    </td>
                  </tr>)
              })
              }
              {(campaignGroupList === null || campaignGroupList === undefined || campaignGroupList.length === 0) &&
            <tr>
              <td colSpan={10}><h2>{t(`${tKey}RESULTS_NOT_FOUND`)}</h2></td>
            </tr>}
              <tr className="button-table-wrapper">
                <td>
                  <Button
                    className="btn-editable-table btn-standard"
                    onClick={() => openCampaignGroupModal()}>
                  + {t(`${tKey}ADD`)}
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="section-users-footer">
            <nav key={1} className="text-center">
              <IDocCarPagination
                id="btn_pag_sales"
                page={page}
                pagesCount={pagesCount}
                totalRows={campaignGroupCount}
                onSelectAction={(value) => fetchCampaignGroupList({ ...filter, ...this.state.filter, page: value })}
              />
            </nav>
          </div>
        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listCampaignGroup'
})(CampaignGroupMaster)
